const Builder = require('../BuilderBase');
const HiddenFor = require('../HiddenFor');
const filters = require('../filters');

module.exports = class DropDown extends Builder {
    constructor(title, properties) {
        super('formElement_DropDown', title, properties);
        if (!properties.namespace || !properties.relation) {
            throw new Error('For DropDowns you must specify a namespace and a relation.');
        }
    }
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    filter(type, properties) {
        const Filter = filters[type];
        const filter = new Filter(properties);
        this.addChildBlock(filter, 'filters');
        return filter;
    }
};
